import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from 'react';

//TODO: den LocalStorage mit der indexDB austauschen, um so auch asynchrone zugriffe zu ermoeglichen!

//TODO: Hier muss je nach Anwendung eine Anpassung an der default Selection, sowie an der default InitialData getätigt werden.
const defaultSelection = {
  "mqtt://rapid3-214:9001": [
    "Pump-Controller"
  ]
}

const defaultInitialData = {
  "mqtt://rapid3-214:9001": {
    "Pump-Controller": {
      "sensor_name": "Pump-Controller",
      "control_data": {
        "pump": {
          "area_name": "Control-Area",
          "publish_type": "button-publish",
          "publish_name": "Apply",
          "values": {
            "mode": {
              "type": "button-select",
              "default_value": "flash and test",
              "values": [
                {
                  "value": "stop"
                },
                {
                  "value": "fill"
                },
                {
                  "value": "clear"
                },
                {
                  "value": "reroll"
                }
              ]
            },
            "interval": {
              "default_value": "1",
              "type": "discrete-slider",
              "step": "1",
              "min": "1",
              "max": "5",
              "marks": [
                {
                  "value": 1,
                  "label": "1"
                },
                {
                  "value": 2,
                  "label": "2"
                },
                {
                  "value": 3,
                  "label": "3"
                },
                {
                  "value": 4,
                  "label": "4"
                },
                {
                  "value": 5,
                  "label": "5"
                }
              ]
            }
          }
        }
      },
      "status_data": {
        "pump": {
          "area_name": "Status-Area",
          "values": {
            "mode": {
              "type": "text"
            },
            "interval": {
              "type": "text"
            },
            "timestamp": {
              "type": "text"
            },
            "distance": {
              "type": "text"
            },
            "fill_level": {
              "type": "liquid-gauge"
            }
          }
        }
      },
      "socket_data": {
        "area_1": {
          "area_name": "Socket_Data",
          "socket_url": "http://livedemo-ws.wellenzahl.online/",
          "control_fields": {
            "serial_interface": "true",
            "raw_data_and_radar_interface": "true",
            "radar_recorder": "true"
          },
          "graphs": {
            "raw_data_plot_1": "true",
            "raw_data_plot_2": "true",
            "target_list_plot": "true",
            "value_list_plot": "true",
            "control_panel": "true"
          }
        }
      },
      "live_stream": "http://rapid3-170:8889/demostream"
    }
  }
}

//getLocalStorageItem reads a value from the localStorage based on the specified key. It is checked whether a value was found, 
//if yes it is returned, if not null is returned.
const _getLocalStorageItem = (key) => {
  if (!key) {
    console.error("Invalid key provided to getLocalStorageItem.");
    return null;
  }
  try {
    const storedValue = localStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : null;
  } catch (error) {
    console.error("Error retrieving from LocalStorage: ", error);
    return null;
  }
}

//setLocalStorageItem saves a transferred value as a JSON string with the corresponding key in the localStorage.
const _setLocalStorageItem = (key, value) => {
  if (!key) {
    console.error("Invalid key provided to setLocalStorageItem.");
    return false;
  }
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    console.error("Error when saving to LocalStorage: ", error);
    return false;
  }
}

//removeLocalStorageItem revomes an Item by the given key from the localStorage.
const _removeLocalStorageItem = (key) => {
  if (!key) {
    console.error("Invalid key provided to removeLocalStorageItem.");
    return false;
  }
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.error("Error when deleting from the LocalStorage: ", error);
    return false;
  }
}

//clear removes all saved entries from the browser's local memory.
const _clearLocalStorage = () => {
  try {
    localStorage.clear();
    console.info("LocalStorage was successfully cleared.");
    return true;
  } catch (error) {
    console.error("Error clearing LocalStorage:", error);
    return false;
  }
};

//getSelection returns the users selection and the sensors of the connected Broker
const _getSelection = () => {
  var selection = _getLocalStorageItem('selection') || {};
  const initialData = _getLocalStorageItem('initial_data') || {};
  let broker = "";

  //Checks whether the saved selection (_getLocalStorageItem('selection')) contains a sensor that no longer exists!
  if (Object.keys(selection).length !== 0) {
    Object.keys(selection).map((broker) => {
      if (!initialData.hasOwnProperty(broker)) {
        delete selection[broker];
        // console.log("Broker: ", broker, " got removed from selection cause it is not availble in initialData");
      } else {
        selection[broker] = selection[broker].filter(sensor => {
          if (!initialData[broker].hasOwnProperty(sensor)) {
            // console.log("Sensor:", sensor, "of the Broker:", broker, "got removed from selection cause it is not available in initialData");
            return false; // Sensor nicht behalten
          }
          return true; // Sensor behalten
        });
        if (selection[broker].length === 0) {
          delete selection[broker];
          // console.log("Broker:", broker, "got removed from selection cause it contains no Sensors");
        }
      }
    })
  }

  //Checks whether the host contains sensors and automatically adds them to the selection
  if (window.location.hostname !== "localhost") {
    broker = "mqtt://".concat(window.location.hostname, ":9001");
    if (initialData.hasOwnProperty(broker)) {
      Object.keys(initialData[broker]).map((sensorName) => {
        if (Object.keys(selection).length === 0) {
          selection = { [broker]: [sensorName] }
        } else {
          if (selection.hasOwnProperty(broker)) {
            if (!selection[broker].includes(sensorName)) {
              selection[broker].push(sensorName);
            }
          } else {
            selection = { ...selection, [broker]: [sensorName] };
          }
        }
      });
    }
  }
  // console.log(selection);
  if (Object.keys(selection).length !== 0) {
    return selection;
  } else {
    return null;
  }
};

//This function wraps a JSON object into a new JSON object under the passed key.
const _wrapObjectWithKey = (object, key) => ({ [key]: object });

const InitialDataContext = createContext(null);
const SelectionContext = createContext(null);

// Provider-Komponente
export const LocalStorageProvider = ({ children }) => {
  // Lade die Daten aus dem localStorage bei der Initialisierung
  const [initialData, setInitialData] = useState(() => _getLocalStorageItem('initial_data') || defaultInitialData);
  const [selection, setSelection] = useState(() => _getSelection() || defaultSelection);

  // Synchronize initialData to localStorage whenever it changes
  useEffect(() => {
    if (initialData) {
      _setLocalStorageItem('initial_data', defaultInitialData);
      setSelection(_getSelection() || defaultSelection);
    }
  }, [initialData]);

  // Synchronize selection to localStorage whenever it changes
  useEffect(() => {
    if (selection) {
      _setLocalStorageItem('selection', selection);
    }
  }, [selection]);

  const _getDataByDataType = useCallback((broker, sensor, dataType) => {
    return initialData?.[broker]?.[sensor]?.[dataType] || null;
  }, [initialData]);

  const _getDataByDataTypeAndArea = useCallback((broker, sensor, dataType, area) => {
    return initialData?.[broker]?.[sensor]?.[dataType]?.[area] || null;
  }, [initialData]);

  const _getValuesByArea = useCallback((broker, sensor, dataType, area) => {
    return initialData?.[broker]?.[sensor]?.[dataType]?.[area]?.values || null;
  }, [initialData]);

  const _getCustomProfilesByArea = useCallback((broker, sensor, dataType, area) => {
    return initialData?.[broker]?.[sensor]?.[dataType]?.[area]?.custom_profiles || null;
  }, [initialData]);

  const updateInitialData = useCallback(({ broker, data }) => {
    try {
      data = JSON.parse(new TextDecoder().decode(data));
    } catch (error) {
      console.error("Failed to parse data:", error);
      return false;
    }

    setInitialData((prevData) => {
      let updatedData = { ...prevData };
      if (updatedData) {
        //console.log("initial_data is available!");
        //A distinction must be made as to whether the broker already exists or not.
        if (updatedData[broker] !== null && initialData[broker] !== undefined) {
          //If the broker already exists, another sensor is added to it.
          updatedData[broker][data.sensor_name] = data;
          // console.log("Broker ", broker, " has been updated: ", updatedData);
        } else {
          updatedData[broker] = _wrapObjectWithKey(data, data.sensor_name);
          // console.log("Broker ", broker, " has been added: ", updatedData);
        }
      } else {
        //If the broker does not yet exist, it is added with the corresponding sensor.
        updatedData = _wrapObjectWithKey(_wrapObjectWithKey(data, data.sensor_name), broker);
        // console.log("InitialDatta has been added: ", updatedData);
      }
      return updatedData;
    });
  }, [initialData]);

  const updateSelection = useCallback((select) => {
    if (select) {
      setSelection(select);
    }
  }, []);

  const getBrokerList = useCallback(() => {
    return initialData ? Object.keys(initialData) : null;
  }, [initialData]);

  const sensorList = useMemo(() => {
    const list = [];
    if (initialData && typeof initialData === 'object') {
      for (const broker in initialData) {
        if (initialData[broker] && typeof initialData[broker] === 'object') {
          list.push(...Object.keys(initialData[broker]));
        }
      }
    }
    return list;
  }, [initialData]);

  const getSensorList = useCallback(() => sensorList, [sensorList]);

  // const getSensorList = useCallback(() => {
  //   return Object.values(initialData).flatMap(brokerData => Object.keys(brokerData));
  // }, [initialData]);

  //Returns the entire SensorData
  const getSensorData = useCallback(({ broker, sensor }) => {
    if (initialData && typeof initialData === 'object') {
      if (initialData.hasOwnProperty(broker) && initialData[broker].hasOwnProperty(sensor)) {
        return initialData[broker][sensor];
      }
    }
    return null;
  }, [initialData]);

  //Returns the SensorData up to the level of the areas
  //TODO: Kann in zukunft entfernt werden, da es nichtmehr verwendet wird!
  const getSensorDataSimplified = useCallback(({ broker, sensor }) => {
    if (initialData && typeof initialData === 'object') {
      if (
        initialData.hasOwnProperty(broker) &&
        initialData[broker].hasOwnProperty(sensor)
      ) {
        const sensorData = initialData[broker][sensor];

        // Extract the required simplified data
        const simplifiedData = {};
        simplifiedData.socket_data = false;

        if (sensorData.control_data) {
          simplifiedData.control_data = Object.keys(sensorData.control_data);
        }

        if (sensorData.status_data) {
          simplifiedData.status_data = Object.keys(sensorData.status_data);
        }

        if (sensorData.socket_data) {
          simplifiedData.socket_data = Object.keys(sensorData.socket_data);
        }

        return simplifiedData;
      }
    }
    return null;
  }, [initialData]);

  const getSensorDataMqttAreas = useCallback(({ broker, sensor }) => {
    if (initialData && typeof initialData === 'object') {
      if (
        initialData.hasOwnProperty(broker) &&
        initialData[broker].hasOwnProperty(sensor)
      ) {
        const sensorData = initialData[broker][sensor];

        // Extract the required simplified data
        const simplifiedData = {};

        if (sensorData.control_data) {
          simplifiedData.control_data = Object.keys(sensorData.control_data);
        }

        if (sensorData.status_data) {
          simplifiedData.status_data = Object.keys(sensorData.status_data);
        }

        return simplifiedData;
      }
    }
    return null;
  }, [initialData]);

  const getSensorDataSensorCard = useCallback(({ broker, sensor }) => {
    if (initialData && typeof initialData === 'object') {
      if (
        initialData.hasOwnProperty(broker) &&
        initialData[broker].hasOwnProperty(sensor)
      ) {
        const sensorData = initialData[broker][sensor];

        // Extract the required simplified data
        const simplifiedData = {};
        simplifiedData.socket_data = false;
        simplifiedData.mqtt_data = false;
        simplifiedData.live_stream = false;

        if (sensorData.sensor_name) {
          simplifiedData.sensor_name = sensorData.sensor_name;
        }

        if (sensorData.control_data || sensorData.status_data) {
          simplifiedData.mqtt_data = true;
        }

        if (sensorData.socket_data) {
          simplifiedData.socket_data = Object.keys(sensorData.socket_data);
        }

        if (sensorData.live_stream) {
          simplifiedData.live_stream = sensorData.live_stream;
        }

        return simplifiedData;
      }
    }
    return null;
  }, [initialData]);

  const getControlData = useCallback(({ broker, sensor }) => {
    return _getDataByDataType(broker, sensor, "control_data");
  }, [_getDataByDataType]);

  const getStatusData = useCallback(({ broker, sensor }) => {
    return _getDataByDataType(broker, sensor, "status_data");
  }, [_getDataByDataType]);

  const getSocketData = useCallback(({ broker, sensor }) => {
    return _getDataByDataType(broker, sensor, "socket_data");
  }, [_getDataByDataType]);

  const getControlDataByArea = useCallback((broker, sensor, area) => {
    return _getDataByDataTypeAndArea(broker, sensor, "control_data", area);
  }, [_getDataByDataTypeAndArea]);

  const getStatusDataByArea = useCallback((broker, sensor, area) => {
    return _getDataByDataTypeAndArea(broker, sensor, "status_data", area);
  }, [_getDataByDataTypeAndArea]);

  const getSocketDataByArea = useCallback((broker, sensor, area) => {
    return _getDataByDataTypeAndArea(broker, sensor, "socket_data", area);
  }, [_getDataByDataTypeAndArea]);

  const getPublishValues = useCallback((broker, sensor, area) => {
    let res = { publishType: null, publishName: null };
    const controlData = _getDataByDataType(broker, sensor, "control_data");
    if (controlData.hasOwnProperty(area) && controlData[area].hasOwnProperty("publish_type")) {
      res.publishType = controlData[area]["publish_type"];
      if (controlData[area].hasOwnProperty("publish_name")) {
        res.publishName = controlData[area]["publish_name"];
      }
      return res;
    } else {
      return null;
    }
  }, [_getDataByDataType]);

  const getControlValues = useCallback((broker, sensor, area) => {
    return _getValuesByArea(broker, sensor, "control_data", area);
  }, [_getValuesByArea]);

  const getStatusValues = useCallback((broker, sensor, area) => {
    return _getValuesByArea(broker, sensor, "status_data", area);
  }, [_getValuesByArea]);

  const getCustomProfiles = useCallback((broker, sensor, area) => {
    let profiles = _getCustomProfilesByArea(broker, sensor, "control_data", area);
    if (profiles !== null && !profiles.hasOwnProperty("default")) {
      const controlData = _getValuesByArea(broker, sensor, "control_data", area);
      const defaultProfile = {};
      for (const key in controlData) {
        if (controlData[key] && controlData[key].default_value) {
          defaultProfile[key] = controlData[key].default_value;
        } else {
          defaultProfile[key] = 0;
        }
      }
      profiles["default"] = defaultProfile;
    }
    return profiles;
  }, [_getCustomProfilesByArea, _getValuesByArea]);

  // Memoization der Context-Werte
  const initialDataContextValues = useMemo(() => ({
    initialData,
    updateInitialData,
    getBrokerList,
    getSensorList,
    getSensorData,
    getSensorDataSimplified,
    getSensorDataMqttAreas,
    getSensorDataSensorCard,
    getControlData,
    getStatusData,
    getSocketData,
    getControlDataByArea,
    getStatusDataByArea,
    getSocketDataByArea,
    getCustomProfiles,
    getPublishValues,
    getControlValues,
    getStatusValues
  }), [initialData,
    updateInitialData,
    getBrokerList,
    getSensorList,
    getSensorData,
    getSensorDataSimplified,
    getSensorDataMqttAreas,
    getSensorDataSensorCard,
    getControlData,
    getStatusData,
    getSocketData,
    getControlDataByArea,
    getStatusDataByArea,
    getSocketDataByArea,
    getCustomProfiles,
    getPublishValues,
    getControlValues,
    getStatusValues]);

  const selectionContextValues = useMemo(() => ({
    selection,
    updateSelection
  }), [selection, updateSelection]);

  return (
    <InitialDataContext.Provider value={initialDataContextValues}>
      <SelectionContext.Provider value={selectionContextValues}>
        {children}
      </SelectionContext.Provider>
    </InitialDataContext.Provider>
  );
};

// Custom Hook zum Zugriff auf den Context
export const useInitialData = () => useContext(InitialDataContext);
export const useSelection = () => useContext(SelectionContext);